import { render, staticRenderFns } from "./BudgetVariants.vue?vue&type=template&id=bb5ac6c4&scoped=true&"
import script from "./BudgetVariants.vue?vue&type=script&lang=ts&"
export * from "./BudgetVariants.vue?vue&type=script&lang=ts&"
import style0 from "./BudgetVariants.vue?vue&type=style&index=0&id=bb5ac6c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb5ac6c4",
  null
  
)

export default component.exports